module.exports = __webpack_public_path__ + "img/中文版_库尔_北京.1c345d04.webp";